import React from 'react';

import PropTypes from 'prop-types';

import GlobalFilter from './globalFilter';
import { Toolbar } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  title: {
    flex: '1 1 100%',
    fontSize: '1.125rem',
  },
}));

const TableToolbar = (props) => {
  const classes = useToolbarStyles();
  const { title, preGlobalFilteredRows, setGlobalFilter, globalFilter } = props;
  return (
    <Toolbar className={classes.root}>
      <div className={classes.title} id="tableTitle">
        {title}
      </div>
      <GlobalFilter
        preGlobalFilteredRows={preGlobalFilteredRows}
        globalFilter={globalFilter}
        setGlobalFilter={setGlobalFilter}
      />
    </Toolbar>
  );
};

Toolbar.prototype = {
  setGlobalFilter: PropTypes.func.isRequired,
  preGlobalFilteredRows: PropTypes.array.isRequired,
  globalFilter: PropTypes.string.isRequired,
};

export default TableToolbar;
